import { Box } from '@mui/material'
import { mobilePaddingX } from '../../theme/mobileLayout'

export const CONTENT_MAX_WIDTH = 1520

export function PageContainer({ children, sx = {}, disablePadding = false, ...props }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: CONTENT_MAX_WIDTH,
        mx: 'auto',
        px: disablePadding ? 0 : mobilePaddingX,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  )
}

export function FullWidthSection({ children, sx = {}, ...props }) {
  return (
    <Box component="section" sx={{ width: '100%', ...sx }} {...props}>
      {children}
    </Box>
  )
}
